.container {
	flex: 1 0 auto;
	display: flex;
	height: 100%;
}
.no-component-mapped {
	height: 100%;
	flex: 1 0 auto;
	text-align: center;
	padding: 8px;
}
